import React from 'react';

interface ExternalMediaIFrameProps {
	embeddedUrl: string;
	title: string;
}
/**
 * This component display external media videos on front end
 */
export default function ExternalMediaIFrame(props: ExternalMediaIFrameProps) {
	const { embeddedUrl, title } = props;
	return (
		<div className="roc-embed-responsive roc-embed-responsive--16by9">
			<iframe
				data-testid="external-media-frame"
				title={title}
				src={embeddedUrl}
				frameBorder="0"
				allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
				allowFullScreen
				className="roc-embed-responsive__item"
			></iframe>
		</div>
	);
}
